const StaffListDropDownIcon = () => {
  return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.1169 6.74702C10.2074 6.66961 10.3323 6.64637 10.4446 6.68604C10.5569 6.72572 10.6395 6.82229 10.6612 6.93938C10.683 7.05646 10.6407 7.17627 10.5502 7.25368L8.21685 9.25368C8.09211 9.36038 7.90826 9.36038 7.78352 9.25368L5.45019 7.25368C5.31027 7.13402 5.29386 6.92359 5.41352 6.78368C5.53318 6.64377 5.74361 6.62735 5.88352 6.74702L8.00019 8.56102L10.1169 6.74768V6.74702Z"
          fill="#262626"
          stroke="#333333"
        />
      </svg>
  );
};
export default StaffListDropDownIcon;
